import { NgModule } from '@angular/core';
import { AuthFormModule } from './auth-form';
import { ListModule } from './list';
import { ButtonModule } from './button';

const MODULES = [
  AuthFormModule,
  ListModule,
  ButtonModule
];

@NgModule({
  imports: MODULES,
  exports: MODULES
})

export class CaaMaterialsModule { }
